// extracted by mini-css-extract-plugin
export default {"modal":"FullScreenModal_modal__AYrfM","modalContent":"FullScreenModal_modalContent__ZyJRh"};